import { render, staticRenderFns } from "./SuperFarmacia.vue?vue&type=template&id=2d79caec&"
import script from "./SuperFarmacia.vue?vue&type=script&lang=js&"
export * from "./SuperFarmacia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports